import { render, staticRenderFns } from "./BaseButtonTable.vue?vue&type=template&id=d9770f32&scoped=true&"
import script from "./BaseButtonTable.vue?vue&type=script&lang=js&"
export * from "./BaseButtonTable.vue?vue&type=script&lang=js&"
import style0 from "./BaseButtonTable.vue?vue&type=style&index=0&id=d9770f32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9770f32",
  null
  
)

export default component.exports